<p-toast></p-toast>
<app-loader [loading]="loading"></app-loader>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-8">
      <h6 *ngIf="!fromStepper" class="title-text pt-3 pb-2">AI Topic Settings</h6>
      <h6 *ngIf="fromStepper" class="text-dark pt-3 pb-2">Configure AI Topics and Subtopics</h6>
    </div>
    <div class="col-sm-4 text-end">
      <button
        type="button"
        class="btn btn-sm btn-add-site-user text-white m-2"
        (click)="openAddTopicModal()">
        <i class="fa fa-plus"></i> Add Topic
      </button>
      <button
        type="button"
        class="btn btn-sm btn-add-site-user text-white m-2"
        (click)="openAddSubTopicModal()">
        <i class="fa fa-plus"></i> Add SubTopic
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <div class="col-md-2" style="padding-bottom: 15px">
        <ng-select
          [placeholder]="'Select Topic'"
          [(ngModel)]="selectedTopic"
          (change)="onTopicChange($event)"
          appendTo="body"
          [clearable]="false"
          style="width: 300px">
          <ng-option
            *ngFor="let topic of topics"
            [value]="topic">
            {{ topic.topic_name }}
          </ng-option>
        </ng-select>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="table-responsive" *ngIf="selectedSubTopics.length > 0">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>SubTopic Name</th>
            <th>Secondary Prompt</th>
            <th>Status</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let subTopic of selectedSubTopics">
            <td>{{ subTopic.sub_topic_name }}</td>
            <td>{{ subTopic.secondary_prompt }}</td>
            <td>
              <span 
                class="badge"
                [class.bg-success]="subTopic.status"
                [class.bg-danger]="!subTopic.status">
                {{ subTopic.status ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td>{{ subTopic.created_date | date:'dd/MM/yyyy HH:mm' }}</td>
            <td>
              <button
                class="action-btn"
                (click)="editSubTopic(subTopic)"
                title="Edit SubTopic">
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="action-btn"
                (click)="deleteSubTopic(subTopic)"
                title="Delete SubTopic">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="no-records" *ngIf="selectedSubTopics.length === 0">
      <p>No SubTopics available for this topic</p>
    </div>
  </div>

  <div class="row" *ngIf="!selectedTopic && !loading">
    <div class="col-sm-12">
      <div class="alert alert-info">
        <i class="fa fa-info-circle"></i>
        No topics available. Please add a topic to get started.
      </div>
    </div>
  </div>
</div>
